import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { usePersonsServiceGetPersonByIdEndpoint } from 'src/api/queries'
import { getFullName } from 'src/features/users/utils'

export const usePatientBreadcrumb = (personId?: string) => {
  const { t } = useTranslation()

  const { data: person, isLoading: isLoadingPerson } =
    usePersonsServiceGetPersonByIdEndpoint(
      { id: String(personId) },
      [personId],
      {
        enabled: !!personId
      }
    )

  const fullName = useMemo(
    () =>
      person
        ? `${t('common.patient')} - ${getFullName(person?.lastName, person?.firstName)}`
        : '',
    [t, person]
  )

  const breadcrumbItems = useMemo(
    () => [
      { title: t('menu.patients') },
      ...(person ? [{ title: fullName }] : [])
    ],
    [t, person, fullName]
  )

  return { breadcrumbItems, fullName, person, isLoadingPerson }
}
